module.exports = __webpack_public_path__ + "img/display_logo1.002f3cba.jpg";